
import React, { useState } from 'react';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { toast } from 'react-toastify';

const ChipPopover = ({ anchorEl, onClose, store }) => {
  const open = Boolean(anchorEl);
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (store?.token) {
      navigator.clipboard.writeText(store.token);
      toast.success("Token copy Successfully !")
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <div className="p-4 max-w-md">
        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
          Token
        </Typography>
        <Typography
          variant="body2"
          className="break-all bg-gray-100 px-2 py-1 rounded text-sm !mb-2"
        >
          {store?.token || 'No token available'}
        </Typography>

        {store?.token && (
          <Button
            variant="outlined"
            size="small"
            startIcon={<ContentCopyIcon />}
            onClick={handleCopy}
          >
            {copied ? 'Copied!' : 'Copy'}
          </Button>
        )}
      </div>
    </Popover>
  );
};

export default ChipPopover;
